import { useState, useContext } from "react";
import { Spinner, OverlayTrigger, Tooltip} from "react-bootstrap";
import NotyfContext from "../contexts/NotyfContext";
import { FileText} from "react-feather";

import authenticatedFetch from "./fetch"

const LinkedDocumentDisplay = ({entityType, filename, entityId}) => {
  const notyf = useContext(NotyfContext);

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClicked = (e) => {
    e.preventDefault();
    setIsDownloading(true);

    authenticatedFetch({
      method: "POST",
      requestData: {filename: filename},
      path:  entityType + "/" + entityId + "/file/signeddownloadurl",
      successHandler: function(result) {
        setIsDownloading(false);
        window.open(result.url);
      },
      errorHandler: function(error) {
        setIsDownloading(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  return (
    isDownloading ?
    <Spinner animation="border" size="sm" />
    :
    <OverlayTrigger
      triggers="[hover,focus]"
      placement="bottom"
      overlay={<Tooltip >{filename}</Tooltip>}
      >
        <FileText style={{ color: "#3AAFA9", height: 16, width: 16, cursor: "pointer" }} onClick={(e) => {handleDownloadClicked(e)}} />
      </OverlayTrigger>
  )
}


const LinkedDocumentsDisplay = ({entityType, documents, entityId}) => {
  if (documents && documents.length > 0) {
    var icons = documents.map((file, idx) => {
      return (
        <span key={idx}><LinkedDocumentDisplay key={idx} filename={file.filename} entityId={entityId} entityType={entityType}/>&nbsp;</span>
      )
    });

    return (
      <>
      {icons}
      </>
    )
  }

  return <></>
}

export default LinkedDocumentsDisplay;